import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "NoEntry.svg",
  "use": "NoEntry.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"NoEntry.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56ZM48,30a2,2,0,0,0-2-2H18a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H46a2,2,0,0,0,2-2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol